import React from 'react';
import clsx from 'clsx';
import styles from '../apartment-filter-list-item/styles.module.scss';
import { isoToKrasnoyarskTime, toReadablePrice, toReadableSquarePrice } from 'lib/utils';
import { squareMetre, TWallMaterial } from 'lib/types';
import { WallMaterial } from 'lib/dictionary';

export type FilterParam = {
  parameterCount: number;
  areaFrom?: number;
  areaTo?: number;

  pricePerSqMFrom?: number;
  pricePerSqMTo?: number;

  priceFrom?: number;
  priceTo: number;

  bedroomCount?: number[];
  wallMaterials?: TWallMaterial[];
  facilityTypeIds?: number[];
  floors?: number[];
  floorCount?: number[];
  commissioningYears?: number[];
  facilityTypes?: string[];
};

export type FilterGroup = {
  title: string;
  createdAt: string;
  id: number;
  unreadCount: number;
  filter: FilterParam;
};

export type ApartmentFilterListItemProps = {
  className?: string;
  onClick?: () => void;
  filterGroup: FilterGroup;
  leftIcon?: React.ReactNode;
};

const ApartmentFilterListItem: React.FC<ApartmentFilterListItemProps> = (props) => {
  const { className, filterGroup, onClick, leftIcon } = props;
  const { title, createdAt, filter, unreadCount } = filterGroup;

  return (
    <div className={clsx(styles.container, className)} onClick={onClick}>
      <div className={styles.description}>
        <div className={styles.housingEstate}>{`Название фильтра: ${title}`}</div>

        <div className={styles.item}>
          <b>Дата создания:</b>
          <span className={styles.price}>{` ${isoToKrasnoyarskTime(createdAt)}`}</span>
        </div>

        {filter?.priceTo && filter?.priceFrom !== null && (
          <div className={styles.item}>
            <b>Цена:</b>
            <span>{` от ${toReadablePrice(filter?.priceFrom!)}`}</span>
            <span>{` до ${toReadablePrice(filter?.priceTo)}`}</span>
          </div>
        )}

        {filter?.pricePerSqMFrom !== null && filter?.pricePerSqMTo && (
          <div className={styles.item}>
            <b>Цена {squareMetre}:</b>
            <span>{` от ${toReadableSquarePrice(filter?.pricePerSqMFrom!)}`}</span>{' '}
            <span>{` до ${toReadableSquarePrice(filter?.pricePerSqMTo)}`}</span>
          </div>
        )}

        {!!filter?.floors?.length && (
          <div className={styles.item}>
            <b>Этажей:</b>
            <span>{` от ${filter?.floors[0]}`}</span>{' '}
            <span>{` до ${filter?.floors[filter?.floors.length - 1]}`}</span>
          </div>
        )}

        {!!filter?.floorCount?.length && (
          <div className={styles.item}>
            <b>Количество этажей:</b>
            <span>{` от ${filter?.floorCount[0]}`}</span>{' '}
            <span>{` до ${filter?.floorCount[filter?.floorCount?.length - 1]}`}</span>
          </div>
        )}

        {!!filter?.commissioningYears?.length && (
          <div className={styles.item}>
            <b>Год:</b>
            <span>{` от ${filter?.commissioningYears[0]} г`}</span>{' '}
            <span>{` до ${
              filter?.commissioningYears[filter?.commissioningYears?.length - 1]
            } г`}</span>
          </div>
        )}

        {!!filter?.wallMaterials?.length && (
          <div className={styles.item}>
            <b>Материал стен: </b>
            <span>
              {filter?.wallMaterials?.length &&
                filter?.wallMaterials.map((wall) => {
                  return `${WallMaterial.label(wall)} `;
                })}
            </span>
          </div>
        )}

        {!!filter?.facilityTypes?.length && (
          <div className={styles.item}>
            <b>Тип квартиры: </b>
            <span>
              {filter?.facilityTypes?.map((type) => {
                return `${type} `;
              })}
            </span>
          </div>
        )}

        <div className={styles.item}>
          <b>Непрочитанных уведомлений: </b>
          {` ${unreadCount ? unreadCount : 0}`}
        </div>
      </div>
      {leftIcon && <div className={clsx(styles.icon, styles.leftIcon)}>{leftIcon}</div>}
    </div>
  );
};

export default ApartmentFilterListItem;
